import React from "react";

const ReturnSvg = ({ size = 25, color = "#ff4400", ...props }) => (
  <svg
    width={size}
    height={size}
    fill={color}
    stroke={color}
    viewBox="0 0 219.272 219.271"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...props} // allow passing extra props like className, onClick, etc.
  >
    <g>
      <path d="M120.774,179.271v40c47.303,0,85.784-38.482,85.784-85.785c0-47.3-38.481-85.782-85.784-85.782H89.282L108.7,28.286 
      L80.417,0L12.713,67.703l67.703,67.701l28.283-28.284L89.282,87.703h31.492c25.246,0,45.784,20.538,45.784,45.783 
      C166.558,158.73,146.02,179.271,120.774,179.271z" />
    </g>
  </svg>
);

export default ReturnSvg;